export default __webpack_public_path__ + "static/koh-samet-1a056ad3e37e10ce96588e0852680f28.jpg";